import { Components, Theme } from '@mui/material'

const MuiButton: Components<Theme>['MuiButton'] = {
  styleOverrides: {
    root: { borderRadius: '9999px' },
  },
}

export default MuiButton
